import SvgIcon from '@/components/common/SvgIcon';
import { Button, ButtonProps } from 'antd';
import { ButtonHTMLType, ButtonVariantType } from 'antd/es/button';
import { ReactNode, forwardRef } from 'react';
import './style.scss';
interface ButtonCustomProps extends ButtonProps {
  iconName?: string;
  children?: ReactNode;
  variant?: ButtonVariantType;
  ghost?: boolean;
  htmlType?: ButtonHTMLType;
}

// forwardRef để Tooltip và các component khác lấy được ref tới DOM button thực tế
const ButtonCustom = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  (
    {
      children,
      variant = 'solid',
      iconName = '',
      htmlType = 'button', // mặc định là 'button'
      ...rest
    },
    ref,
  ) => {
    return (
      <Button
        ref={ref} // truyền ref xuống Button của AntD
        variant={variant}
        color="primary"
        htmlType={htmlType}
        {...rest}
      >
        {(!!children || !!iconName) && (
          <div className="d-flex-center">
            {iconName && (
              <SvgIcon name={iconName} className={children ? 'mr-8' : ''} />
            )}
            {!!children && <span>{children}</span>}
          </div>
        )}
      </Button>
    );
  },
);

ButtonCustom.displayName = 'ButtonCustom'; // để debug tốt hơn

export default ButtonCustom;
